import React from "react";
import { useFormContext } from "react-hook-form";
import InputArea from "../../../common/components/FormFields/InputArea";
import "./DropdownInput.css";
import ExpandingTextArea from "./ExpandingTextArea";

export default function HighRiskFactors() {
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  return (
    <div className="">
      <div className="flex justify-between bg-[#FCDDCB] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">High Risk Factors</p>
        <div className="flex my-auto"></div>
      </div>
      <div className="p-2 w-full border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        <InputArea
          control={control}
          label="High Risk Factors"
          name="highRisk"
          sx={{
            color: "red",
            fontWeight: "bolder",
            minHeight: "4rem",
            ".css-1oih5lp-JoyTextarea-root": {},
          }}
          minRows={2}
        />
        {/* <ExpandingTextArea /> */}
      </div>
    </div>
  );
}

